import React from "react";

export const Logo = ({ size }) => {
	return (
		<img
			src="./logo512.png"
			alt="Logo"
			width={size}
			height={size}
		/>
	);
};
